import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cache_ready",
  "use": "cache_ready-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"cache_ready\"><path d=\"M5 18a5 5 0 0 1-.949-9.91C4.433 4.653 6.951 2 10 2c3.314 0 6 3.134 6 7 0 .34-.02.676-.061 1.004L16 10a4 4 0 1 1 0 8H5Z\" opacity=\".15\" /><path d=\"m17.27 3.626.748.665a.5.5 0 0 1 .044.703l-7.002 9.003-.316.354a.5.5 0 0 1-.686.059l-.412-.334-3-3a.5.5 0 0 1-.036-.666l.624-.78a.5.5 0 0 1 .744-.042l2.284 2.284 6.3-8.201a.5.5 0 0 1 .709-.045Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol